app.directive('tickpChart', [
    '$timeout', '$ionicLoading', 'chartThemes', 'ServerTimeService',
    function ($timeout, $ionicLoading, chartThemes, ServerTimeService) {
        return {
            restrict: 'E',
            scope: {
                asset: '<',
                chart: '<'
            },
            replace: true,
            link: function (scope, element) {
                var chart,
                    chartEl,
                    ready,
                    gestures = [],
                    asset,
                    chartType = {
                        'line': 3,
                        'ohlc': 2,
                        'candlestick': 1
                    };

                var assetWatch = scope.$watch('chart.ready', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal) {
                        chart = null;
                        element.children().remove();
                        $ionicLoading.show({noBackdrop: true});
                        $timeout(function () {
                            createChart(scope.chart.data);
                            $ionicLoading.hide();
                        }, 350);

                    }
                });

                var assetUpdateWatch = scope.$watch('asset.lastUpdateTime', function (newVal, oldVal) {
                    if (newVal && newVal !== oldVal && ready) {
                        chart && updatePoint();
                    }
                });

                var candleCreateWatch = scope.$watch(function () {
                    return ServerTimeService.time
                }, function (newVal, oldVal) {
                    if (newVal !== oldVal && chart) {
                        chart && newPoint();
                    }
                });

                var chartTypeWatch = scope.$watch('chart.type', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal) {
                        if (chart) {
                            chart.cp.type = chartType[newVal.type];
                            chartRedraw();
                        }
                    }
                });

                var chartRangeWatch = scope.$watch('chart.range', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal) {
                        chart && chartRedraw();
                    }
                });

                function createChart(data) {
                    chart = tickp(element[0], {theme: chartThemes.light, moment: moment, hammer: Hammer});

                    set_textRenderContext(chart.ctx);
                    chart.initDataGraph([], function (d, e) {
                        alert(e);
                    }, []);

                    chart.setSize(element[0].clientWidth, element[0].clientHeight);

                    data.forEach(function (point) {
                        chart.addCandleWithoutPlot(point[0], point[1], point[2], point[3], point[4]);
                    });

                    chart.showVolumeChart(false);
                    chart.setCandleBorder('#999999', 0);
                    chart && chart.setDigits(scope.asset.digits);

                    chart.changemode(1);
                    chart.setTimeScale(0);

                    chart.cp.type = chartType[scope.chart.type.type]

                    chart.horizontallines = [];
                    chart.verticallines = [];
                    chart.setCrossHairVisibility(false);

                    chartRedraw();

                    chartEl = element.find('canvas')[1];

                    ready = true;
                }

                function getLastPoint() {
                    var ohlc = chart.current.ohlc[chart.current.ohlc.length - 1],
                        ts = chart.current.ts[chart.current.ts.length - 1];
                    return [ts].concat(ohlc);
                }

                function updatePoint() {
                    var lastPoint = getLastPoint(),
                        point = [scope.asset.ask, scope.asset.bid],
                        high = point[1] > lastPoint[2] ? point[1] : lastPoint[2],
                        low = point[1] < lastPoint[3] ? point[1] : lastPoint[3];

                    chart.updateRecord(lastPoint[0] + ',' + lastPoint[1] + ',' + high + ',' + low + ',' + point[1]);
                    chartRedraw();
                }

                function newPoint() {
                    var lastPoint = getLastPoint(),
                        time = ServerTimeService.time,
                        timeToAdd = (time % (parseInt(scope.chart.range, 10) * 60 * 1000));
                    if (timeToAdd === 0) {
                        chart.addNewRecord(time + "," + lastPoint[4] + "," + lastPoint[4] + "," + lastPoint[4] + "," + lastPoint[4]);
                        //this.updateExtremes(lastPoint[1]);
                        chartRedraw();
                    }
                }

                function chartRedraw() {
                    chart.preparePlot();
                    chart.plot();
                }


                element.on('$destroy', function () {
                    //unsubscribe local watchers
                    assetWatch();
                    assetUpdateWatch();
                    candleCreateWatch();
                    chartTypeWatch();
                    chartRangeWatch();

                    if (gestures.length > 0) {
                        gestures.forEach(function (item) {
                            ionic.EventController.offGesture(item.ref, item.gesture, item.handler);
                        })
                    }
                    log('chart destroy');
                });

            },
            template: '<div style="position: relative" class="chart" id="chart"></div>'
        }
    }]);